<div class="plus-btn-property" *ngIf="tableViewPage">
  <button type="button" class="btn add-btn-outline1" (click)="addSetup()">
    <em class="bx bx-plus me-1"></em>
    Add Navigation Setup
  </button>
</div>

<div class="col-sm-12" *ngIf="addBtnPage">
  <div class="d-flex">
    <button style="border: none !important;" class="btn btn-primary1" (click)="onBack()">
      <span class="back-light"><em class="mdi mdi-arrow-left me-2"></em>Back</span>
    </button>
    <h4 class="addEditBtn" style="margin-top: 10px;">/ {{title}} Navigation Setup</h4>
  </div>
</div>

<div class="row" *ngIf="tableViewPage">
  <div class="col-sm-3">
    <label>City<sup class="mandatory">*</sup></label>
    <select class="form-select margin-right-8px" placeholder="City" [(ngModel)]="selectedCity"
      (change)="onLocationChange(1, '')">
      <option disabled value="">Choose City</option>
      <option *ngFor="let city of cities" [value]="city.locationId">
        {{ city.locationName }}
      </option>
    </select>
  </div>
</div>

<div class="d-flex justify-content-between mt-5" *ngIf='ELEMENT_DATA.length > 0 && !addBtnPage' style="width: 250px;">
  <input class="form-control icon s-input b-0" type="text" placeholder="Search by Site Name" [(ngModel)]="searchData"
    (input)="onSearchKey(searchData)">
</div>


<div class="row mt-3" *ngIf="addBtnPage">
  <div class="col-sm-12">
    <form [formGroup]="_mFormGroup">
      <div class="row">
        <div class="col-sm-3">
          <label>Site<sup class="mandatory">*</sup></label>
          <select class="form-select margin-right-8px" placeholder="Select Site" formControlName="site" required
            (change)="getShiftsTimes()">
            <option disabled value="">Choose Site</option>
            <option *ngFor="let site of mSites" [value]="site.siteId">
              {{ site.siteName}}
            </option>
          </select>
          <div class="error-msg"
            *ngIf="_mFormGroup.get('site').hasError('required') && _mFormGroup.get('site').touched">
            Please select site
          </div>
        </div>
        <div class="col-sm-3">
          <label>Navigation Type<sup class="mandatory">*</sup></label>
          <select class="form-select margin-right-8px" placeholder="Select Navigation Type"
            formControlName="routingType" required>
            <option disabled value="">Choose Navigation Type</option>
            <option *ngFor="let type of mRoutingTypes" [value]="type.value">
              {{ type.value}}
            </option>
          </select>
          <div class="error-msg"
            *ngIf="_mFormGroup.get('routingType').hasError('required') && _mFormGroup.get('routingType').touched">
            Please select navigation type
          </div>
        </div>
        <div class="col-sm-3">
          <label>Shifts<sup class="mandatory">*</sup></label>
          <ng-multiselect-dropdown class="navigation-multisel" style="width:100%;padding-top: 20px;"
            [placeholder]="'Shifts'" formControlName="shift" [settings]="shiftDropDownSettings" [data]="shiftData"
            (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
          </ng-multiselect-dropdown>
        </div>
        <div class="col-sm-3"
          style="display: flex; justify-content: flex-end; align-items: center; position: relative; top: 14px;">
          <button type="button" [disabled]="!_mFormGroup.valid" class="btn btn-navigation-setup" (click)="onSubmit()">
            Submit
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="row mt-3" *ngIf="tableViewPage">
  <div class="col-sm-12 col-md-12">
    <app-basic-table [columnHeaders]="_mColumns" [tableData]="_mData" (onStatusChanged)="onStatusChanged($event)"
      [subcribeEdit]="subcribeEdit" (onEditIconClicked)="onEditIconClicked($event)" [isAuditLog]="auditFlag"
      (onAuditLog)="onAuditLogClicked($event)"></app-basic-table>
  </div>
  <ngb-pagination class="d-flex justify-content-end" *ngIf="_mData.length > 0" [collectionSize]="
    _mTotalElements " [pageSize]=" _mSize "
    [(page)]=" pageNo " (pageChange)=" onNewPageRequest($event)" [maxSize]="_mSize" [boundaryLinks]="true">
  </ngb-pagination>
</div>

<div class="row mt-3" *ngIf="_mData.length == 0 && _mDataRaw.length > 0">
  <div class="col-sm-12 col-md-12">
    <h4 class="tdw-text-align-center tdw-font-normal tdw-margin-4
            mat-color-text--blue-grey-600">
      --No Data Found --</h4>
  </div>
</div>